import { render } from "storyblok-rich-text-react-renderer"
import { Conditional } from "iq-blueberry"

import { OutlineChevronLeft, OutlineChevronRight } from "@mkt/ui/icons/Cp/index"

import useSlider from './hooks';
import * as S from "./styles"
import {
  getSlidesWidth,
  getDeskConfig,
  getTabletConfig,
  getMobileConfig,
  inPixels,
} from './helpers';

const Slider = ({ title, subtitle, config, numberOfSlides, fillEmptySpace = false, children }) => {
  const {
    itemsPerView = 1,
    gap = 24,
    showSlidesTail = false,
    showNavigation = true,
    showHeader = true,
    showDots = false,
    scrollAlign = 'center',
    scrollBy = 'single',
  } = getMobileConfig(config);

  const {
    itemsPerView: itemsPerViewTablet = 3,
    gap: gapTablet = 24,
    showSlidesTail: showSlidesTailTablet = false,
    showNavigation: showNavigationTablet = true,
    showHeader: showHeaderTablet = true,
    showDots: showDotsTablet = false,
    scrollAlign: scrollAlignTablet = 'start',
    scrollBy: scrollByTablet = 'single',
  } = getTabletConfig(config);

  const {
    itemsPerView: itemsPerViewDesk = 3,
    gap: gapDesk = 24,
    showSlidesTail: showSlidesTailDesk = false,
    showNavigation: showNavigationDesk = true,
    showHeader: showHeaderDesk = true,
    showDots: showDotsDesk = false,
    scrollAlign: scrollAlignDesk = 'center',
    scrollBy: scrollByDesk = 'single',
  } = getDeskConfig(config);

  const slideWidth = getSlidesWidth({
    itemsPerView,
    tail: showSlidesTail,
    gap,
  });

  const slideWidthTablet = getSlidesWidth({
    itemsPerView: itemsPerViewTablet,
    tail: showSlidesTailTablet,
    gap: gapTablet,
  });

  const slideWidthDesk = getSlidesWidth({
    itemsPerView: itemsPerViewDesk,
    tail: showSlidesTailDesk,
    gap: gapDesk,
  });

  const sliderCSSVars = {
    gap: inPixels(gap),
    gapTablet: inPixels(gapTablet),
    gapDesk: inPixels(gapDesk),
    displayNavigation: showNavigation ? 'flex' : 'none',
    displayNavigationTablet: showNavigationTablet ? 'flex' : 'none',
    displayNavigationDesk: showNavigationDesk ? 'flex' : 'none',
    showHeader: showHeader && title || showNavigation ? 'flex' : 'none',
    showHeaderTablet: showHeaderTablet && title || showNavigationTablet ? 'flex' : 'none',
    showHeaderDesk: showHeaderDesk && title || showNavigationDesk ? 'flex' : 'none',
    slideWidth,
    slideWidthTablet,
    slideWidthDesk,
    scrollAlign: scrollAlign,
    scrollAlignTablet: scrollAlignTablet,
    scrollAlignDesk: scrollAlignDesk,
    displayDots: showDots ? 'flex' : 'none',
    displayDotsTablet: showDotsTablet ? 'flex' : 'none',
    displayDotsDesk: showDotsDesk ? 'flex' : 'none',
  };

  const {
    index,
    isLeftBtnDisabled,
    isRightBtnDisabled,
    handleScrollRight,
    handleScrollLeft,
    handleNavigationArrows,
    holderRef,
    trailRef,
    fillSpace,
  } = useSlider({
    gap,
    itemsPerView,
    itemsPerViewTablet,
    itemsPerViewDesk,
    scrollBy,
    scrollByTablet,
    scrollByDesk,
    numberOfSlides,
  });

  return (
    <div css={S.slider}>
      <div css={S.content}>
        <div>
          <div css={S.header(sliderCSSVars)}>
            <div css={S.title}>
              <span>{render(title)}</span>
            </div>

            <div css={S.navigation("top", sliderCSSVars)}>
              <span css={S.index}>{index}</span>

              <div css={S.arrowHolder}>
                <button
                  onClick={handleScrollLeft}
                  css={S.arrowBtn(isLeftBtnDisabled)}
                >
                  <OutlineChevronLeft />
                </button>
              </div>
              <div css={S.arrowHolder}>
                <button
                  onClick={handleScrollRight}
                  css={S.arrowBtn(isRightBtnDisabled)}
                >
                  <OutlineChevronRight />
                </button>
              </div>
            </div>
          </div>

          <div css={S.subtitle}>
            <span>{render(subtitle)}</span>
          </div>
        </div>

        <div css={S.navigation("bottom", sliderCSSVars)}>
          <div css={S.arrowHolder}>
            <button
              onClick={handleScrollLeft}
              css={S.arrowBtn(isLeftBtnDisabled)}
            >
              <OutlineChevronLeft />
            </button>
          </div>

          <span css={S.index}>{index}</span>

          <div css={S.arrowHolder}>
            <button
              onClick={handleScrollRight}
              css={S.arrowBtn(isRightBtnDisabled)}
            >
              <OutlineChevronRight />
            </button>
          </div>
        </div>

        <div ref={holderRef} css={S.trailHolder}>
          <div
            ref={trailRef}
            css={S.trail(sliderCSSVars)}
            onScroll={handleNavigationArrows}
          >
            {children}
            <Conditional
              condition={!!fillEmptySpace && fillSpace > 0}
              renderIf={Array(fillSpace).fill(<div class="slide"/>)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Slider
